import React, { useState, createContext } from 'react';
import PropTypes from 'prop-types';
import * as QueryString from 'query-string';

/**
 * This context provides a wrapper around the application that allows the user to
 * enter and exit debug mode by specifying 'debug' in the query string.
 *
 * Example:
 * https://vistaprint.pt/od?orderId=VPDEV_test_order&confirm&debug
 */

const DEBUG_ENABLED_FLAG_QUERY_STRING_KEY = 'debug';

const DebugModeContext = createContext(null);

const parseQueryString = () => {
  if (typeof window === `undefined`) {
    return [];
  }
  const { search } = window.location;
  if (!search) return [];

  const queryStringKeyValueMap = QueryString.parse(search);
  const queryStringKeySet = Object.keys(queryStringKeyValueMap);
  return [queryStringKeyValueMap, queryStringKeySet];
};

const enableDebugFeature = queryStringKeys => {
  if (!queryStringKeys) return false;
  return queryStringKeys.includes(DEBUG_ENABLED_FLAG_QUERY_STRING_KEY);
};

const DebugModeProvider = props => {
  const { children } = props;

  const [, qsKeys] = parseQueryString();
  const [debugEnabled, setDebugEnabled] = useState(enableDebugFeature(qsKeys));
  const [modBossLogLevel, setModBossLogLevel] = useState('Silent');

  return (
    <DebugModeContext.Provider
      value={{
        debugEnabled,
        setDebugEnabled,
        modBossLogLevel,
        setModBossLogLevel,
      }}
    >
      {children}
    </DebugModeContext.Provider>
  );
};

DebugModeProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export { DebugModeContext, DebugModeProvider };
